import ContentLayout from "components/layout/ContentLayout";
import styled, { css } from "styled-components";
import { mediaMax, mediaMin } from "utils/theme";
import Button from "../Button";
import { RouterLink } from "../Link";

export const LogoWrapper = styled.div`
  padding: 16px;
  flex: 0 0 auto;

  ${mediaMax("lg")} {
    display: none;
  }

  img {
    display: block;
    width: 100%;
    max-height: 32px;
    max-width: 240px;
    object-fit: contain;
    object-position: left center;
  }
`;

export const Wrapper = styled.nav`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;

  ${mediaMin("lg")} {
    display: flex;
    max-width: none;
    background: white;
    box-shadow: ${(props) => props.theme.shadows.large};
  }
`;

export const NavInner = styled(ContentLayout)`
  ${mediaMin("lg")} {
    width: 100%;
    display: flex;
    gap: 16px;
  }
`;

export const NavItems = styled.ul<{ $showMobileMenuButton: boolean }>`
  display: flex;
  justify-content: flex-end;
  margin: 0;
  padding: 0;
  flex: 1 1 auto;

  ${mediaMax("lg")} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    ${(props) =>
      props.$showMobileMenuButton &&
      css`
        position: relative;

        padding-right: 24px;
      `}
  }
`;

export const NavButton = styled(Button)`
  margin: 0 12px;
`;

export const NavItem = styled.li<{ $isDesktopOnly?: boolean }>`
  display: flex;
  align-items: center;

  list-style-type: none;

  ${mediaMax("lg")} {
    justify-content: center;

    ${(props) =>
      props.$isDesktopOnly &&
      css`
        display: none;
      `}
  }

  &:last-child {
    ${NavButton} {
      margin-right: 0;
    }
  }
`;

export const NavLink = styled(RouterLink)<{ $isActive: boolean }>`
  display: flex;
  gap: 2px;
  flex-direction: column;
  align-items: center;

  color: ${(props) => props.theme.colors.text};

  font-family: ${(props) => props.theme.fonts.body};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  text-decoration: none;

  ${mediaMin("lg")} {
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    flex-direction: row;
    gap: 8px;

    ${(props) =>
      props.$isActive
        ? `
    background: ${(props) => props.theme.colors.accent}11;
`
        : ""}
  }
`;

export const Label = styled.div<{ $isActive: boolean }>`
  font-size: ${(props) => props.theme.fontSizesUI.sm}px;
  line-height: 1.33;

  ${(props) =>
    !props.$isActive
      ? `
    opacity: 0.5;
  `
      : ""}

  ${mediaMin("lg")} {
    font-size: ${(props) => props.theme.fontSizesUI.md}px;

    svg {
      height: 18px;
    }
  }
`;

export const MobileMenuButton = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 24px;

  ${mediaMin("lg")} {
    display: none;
  }
`;
